<template>
  <div class="beneficiary-person-form-container">
    <el-dialog
      title="Update Beneficiary"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :width="device === 'mobile' ? '95%' : '80%'"
      :before-close="handleClose"
      top="5vh"
    >
      <el-form
        v-if="beneficiaryForm"
        :model="beneficiaryForm"
        id="beneficiaryForm"
        ref="beneficiaryForm"
        label-width="150px"
        size="small"
        :rules="beneficiaryFormRules"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">Beneficiary</el-divider>
            <el-form-item prop="currency" label="Currency">
              <el-select v-model="beneficiaryForm.currency">
                <el-option label="GBP" value="gbp"></el-option>
                <el-option label="EUR" value="eur"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              prop="name"
              label="Account number"
              v-if="beneficiaryForm.currency === 'gbp'"
            >
              <el-input v-model="beneficiaryForm.accountnumber"></el-input>
            </el-form-item>

            <el-form-item
              prop="sortcode"
              label="Sortcode"
              v-if="beneficiaryForm.currency === 'gbp'"
            >
              <el-input v-model="beneficiaryForm.sortcode"></el-input>
            </el-form-item>

            <el-form-item prop="iban" label="IBAN" v-if="checkGBP">
              <el-input v-model="beneficiaryForm.iban"></el-input>
            </el-form-item>

            <el-form-item prop="bic" label="BIC" v-if="checkGBP">
              <el-input v-model="beneficiaryForm.bic"></el-input>
            </el-form-item>


            <el-divider content-position="left">Personal</el-divider>

            <el-form-item prop="name" label="Name">
              <el-input v-model="beneficiaryForm.personal.name"></el-input>
            </el-form-item>

            <el-form-item prop="dateOfBirth" label="Date Of Birth">
              <el-date-picker
                v-model="beneficiaryForm.personal.dateOfBirth"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="telephone" label="Telephone">
              <el-input
                prefix-icon="el-icon-phone"
                v-model="beneficiaryForm.personal.telephone"
              ></el-input>
            </el-form-item>

            <el-form-item prop="email" label="Email">
              <el-input
                prefix-icon="el-icon-message"
                v-model="beneficiaryForm.personal.email"
              ></el-input>
            </el-form-item>

            <el-form-item prop="pep" label="PEP">
              <el-switch v-model="beneficiaryForm.personal.pep"></el-switch>
            </el-form-item>

            <el-form-item
              prop="pepType"
              label="PEP Type"
              v-if="beneficiaryForm.personal.pep"
            >
              <el-select v-model="beneficiaryForm.personal.pepType">
                <el-option label="Direct" value="direct"></el-option>
                <el-option
                  label="Close associate"
                  value="close-associate"
                ></el-option>
                <el-option label="Former pep" value="former-pep"></el-option>
                <el-option
                  label="Family member"
                  value="family-member"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              prop="pepNotes"
              label="PEP Note"
              v-if="beneficiaryForm.personal.pep"
            >
              <el-input v-model="beneficiaryForm.personal.pepNotes"></el-input>
            </el-form-item>

            <!-- <el-form-item prop="approvedate" label="Approve Date">
              <el-input
                v-model="beneficiaryForm.personal.approvedate"
              ></el-input>
            </el-form-item> -->

            <el-form-item prop="nationality" label="Nationality">
              <el-autocomplete
                prefix-icon="el-icon-s-flag"
                class="inline-input"
                v-model="beneficiaryForm.personal.nationality"
                :fetch-suggestions="querySearchNationality"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item prop="identifyType" label="Identify Type">
              <el-select v-model="beneficiaryForm.personal.identifyType">
                <el-option label="Passport" value="passport"></el-option>
                <el-option
                  label="Driving Licence"
                  value="driving-licence"
                ></el-option>
                <el-option
                  label="Identity Card"
                  value="identity-card"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="identifyNumber" label="Identify Number">
              <el-input
                v-model="beneficiaryForm.personal.identifyNumber"
              ></el-input>
            </el-form-item>

            <el-form-item prop="identifyExpire" label="Identify Expire">
              <el-date-picker
                v-model="beneficiaryForm.personal.identifyExpire"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">Personal Address</el-divider>

            <el-form-item prop="addressnumber" label="Address number">
              <el-input
                v-model="beneficiaryForm.personal.addressnumber"
              ></el-input>
            </el-form-item>

            <el-form-item prop="street" label="Street">
              <el-input v-model="beneficiaryForm.personal.street"></el-input>
            </el-form-item>

            <el-form-item prop="city" label="City">
              <el-input v-model="beneficiaryForm.personal.city"></el-input>
            </el-form-item>

            <el-form-item prop="zipcode" label="Zipcode">
              <el-input v-model="beneficiaryForm.personal.zipcode"></el-input>
            </el-form-item>

            <el-form-item prop="refinement" label="Refinement">
              <el-input
                v-model="beneficiaryForm.personal.refinement"
              ></el-input>
            </el-form-item>

            <el-form-item prop="region" label="Region">
              <el-input v-model="beneficiaryForm.personal.region"></el-input>
            </el-form-item>

            <el-form-item prop="residentCountry" label="Resident Country">
              <el-autocomplete
                class="inline-input"
                v-model="beneficiaryForm.personal.residentCountry"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectResidentCountrycode"
                :maxlength="3"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template></el-autocomplete
              >
            </el-form-item>

            <el-form-item prop="countrycode" label="Country code">
              <el-autocomplete
                class="inline-input"
                v-model="beneficiaryForm.personal.countrycode"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectCountrycode"
                :maxlength="3"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template></el-autocomplete
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="submiting"
          @click="submitBeneficiary()"
          >Submit</el-button
        >
        <el-button @click="handleClose">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUtility } from "@/api/customer";
import { updateBeneficiary } from "@/api/beneficiary";
export default {
  props: {
   
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    checkGBP(){
      return (this.beneficiaryForm.flagswiftfx === 'international' && this.beneficiaryForm.currency === 'gbp') || this.beneficiaryForm.currency != 'gbp';
    }
  },
  data() {
    return {
      dialogShow: false,
      submiting: false,
      errMsg: "",
      utility: {},
      beneficiaryForm: null,
      beneficiaryFormRules: {},
    };
  },
  methods: {
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.utility = data;
        }
      });
    },
    setModel(beneficiaryID, formData){
      this.beneficiaryID = beneficiaryID
      this.beneficiaryForm = formData
      this.dialogShow = true
    },
    updateBeneficiary() {
      this.submiting = true;
      this.errMsg = "";
      updateBeneficiary(this.beneficiaryID, this.beneficiaryForm).then(
        ({ result, message }) => {
          this.submiting = false;
          if (result) {
            this.$notify({
              title: "Success",
              message: `Update Beneficiary successfully`,
              type: "success",
              duration: 2000
            });
            this.handleClose();
            this.$emit("on-submited", true);
          } else {
            this.errMsg =
              typeof message === "string"
                ? message
                : "Update Beneficiary Error";
          }
        }
      );
    },
    submitBeneficiary() {
      //this.$emit("on-submited", true);
      this.$refs.beneficiaryForm.validate((valid) => {
        if (valid) {
          this.updateBeneficiary();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      if (this.$refs.beneficiaryForm) this.$refs.beneficiaryForm.resetFields();
    },

    querySearchCountrycode(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;
      // const lists = []
      // results.forEach((item)=>{
      //   lists.push({value : item.country_code})
      // })
      cb(results);
    },
    querySearchResidentCountry(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;
      // const lists = []
      // results.forEach((item)=>{
      //   lists.push({value : item.country_name})
      // })
      cb(results);
    },
    querySearchNationality(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "nationality"))
        : data;
      const lists = [];
      results.forEach((item) => {
        lists.push({ value: item.nationality });
      });
      cb(lists);
    },

    selectCountrycode(item) {
      this.beneficiaryForm.personal.countrycode = item.country_code;
    },
    selectResidentCountrycode(item) {
      this.beneficiaryForm.personal.residentCountry = item.country_code;
    },
    createFilter(queryString, key) {
      return (item) => {
        return item[key].toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleClose() {
      this.dialogShow = false
    },
  },
  created() {
    this.resetForm();
    this.getUtility();
  },
};
</script>

<style lang="scss">
.beneficiary-person-form-container {
  .el-form-item--small.el-form-item {
    margin-bottom: 16px;
  }
  .item__label {
    line-height: 30px;
    font-weight: bold;
  }

  .el-form-item__label {
    font-size: 12px;
  }

  .el-divider__text {
    font-weight: bold;
    font-size: 14px;
    color: #424242;
  }
}
</style>